import { Routes } from '@/router/constants';
import { LinkTypeEnum } from '@/features/menu-management/constants/menuConstants';

export class NavigationService {
  static handleLinkNavigation(link: any, router?: any): void {
    if (link.type === LinkTypeEnum.Wordpress) {
      const pageRoute = `${Routes.Business}/${link.url}`;

      if (router) {
        router.push(pageRoute);
      } else {
        window.location.href = pageRoute;
      }
      return;
    }

    if (link.type === LinkTypeEnum.Ward) {
      if (!link.url) return;
      if (router) {
        router.push(link.url);
      } else {
        window.location.href = link.url;
      }
      return;
    }

    if (link.type === LinkTypeEnum.External) {
      if (link.url) {
        window.open(link.url, '_blank', 'noopener,noreferrer');
      }
      return;
    }

    if (!link.type && !link.url) {
      const pageRoute = `${Routes.Business}/${link.id}`;
      if (router) {
        router.push(pageRoute);
      }
      return;
    }

    if (link.url) {
      window.open(link.url, '_blank', 'noopener,noreferrer');
    }
  }
}
